const routes = {
    domain: {
        url: 'https://sav.volarenglobo.com.mx/api/',
        //url: 'http://localhost:8000/api/',
    },
    apis: {
        login: 'token',
        validate_token: 'user/validate',
        guest_qr: 'guest/qr',
        user_qr: 'qr',
    }
}

export default routes;